import extendTheme from './extendTheme';
const defaultTheme = extendTheme();
export default defaultTheme;